import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import logo from "../../assets/images/main/logo.png";

import { useSiteContent } from "../../content/SiteContentContext.jsx";

const Header = () => {
  const { navLinks } = useSiteContent();
  const [toggle, setToggle] = useState(false);
  const visibleLinks = navLinks.filter((nav) => nav?.title && nav?.link);
  const primaryLinks = visibleLinks.filter((nav) => nav.title.toLowerCase() !== "contacto");
  const contactLink = visibleLinks.find((nav) => nav.title.toLowerCase() === "contacto") || {
    id: "contacto",
    title: "Contacto",
    link: "/contacto",
  };

  return (
    <header className="site-header">
      <div className="site-header__bar">
        <div className="site-header__inner">
          <Link to="/" className="site-header__brand" onClick={() => setToggle(false)}>
            <span className="site-header__logoWrap">
              <img src={logo} alt="INCAP" className="site-header__logo" />
            </span>
            <span className="site-header__brandText">
              <span className="site-header__brandName">INCAP</span>
              <span className="site-header__brandMeta">Instituto de Capacitación y Aprendizaje Permanente</span>
            </span>
          </Link>

          <nav className="site-header__nav" aria-label="Menú principal">
            {primaryLinks.map((nav) => (
              <NavLink
                key={nav.id || nav.link}
                to={nav.link}
                className={({ isActive }) => (isActive ? "site-header__link site-header__link--active" : "site-header__link")}
              >
                {nav.title}
              </NavLink>
            ))}
          </nav>

          <div className="site-header__actions">
            <NavLink to={contactLink.link} className="site-header__cta">
              {contactLink.title}
            </NavLink>
            <button
              type="button"
              className={toggle ? "site-header__menu site-header__menu--open" : "site-header__menu"}
              aria-label={toggle ? "Cerrar menú" : "Abrir menú"}
              aria-expanded={toggle}
              onClick={() => setToggle((current) => !current)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </div>

      <div className={toggle ? "site-header__mobile site-header__mobile--open" : "site-header__mobile"}>
        <nav className="site-header__mobileNav" aria-label="Menú móvil">
          {visibleLinks.map((nav) => (
            <NavLink
              key={nav.id || nav.link}
              to={nav.link}
              className={({ isActive }) => (isActive ? "site-header__mobileLink site-header__mobileLink--active" : "site-header__mobileLink")}
              onClick={() => setToggle(false)}
            >
              {nav.title}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
